import { SAMPLE_ACCOUNT_CASES } from './sampleAccountCases';
import type { AccountCase } from './types';

// Same shape as the other Account list hooks, so wiring svc-contracting only replaces this body.
export function useAccountCases(_accountId: string): {
  cases: ReadonlyArray<AccountCase>;
  error: Error | null;
  isLoading: boolean;
} {
  return { cases: SAMPLE_ACCOUNT_CASES, error: null, isLoading: false };
}
